<div class="content-list content">
  <div class="content-list__head">
    <div class="title">Settings</div>
    <span class="spacer"></span>

    @if (currentLoaded) {
      <mat-form-field
        appearance="outline"
        class="action-form"
        subscriptSizing="dynamic"
        style="margin-right: 20px; width: 20%"
        >
        <mat-label>Client</mat-label>
        <input
          type="text"
          placeholder="Pick one"
          aria-label="Client"
          matInput
          [(ngModel)]="currentOrganization"
          [formControl]="organizationControl"
          [matAutocomplete]="auto"
          />
        <mat-autocomplete
          autoActiveFirstOption
          #auto="matAutocomplete"
          [displayWith]="displayFn"
          >
          @for (organization of organizationFilteredOptions | async; track organization) {
            <mat-option
              [value]="organization"
              >
              {{ organization.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    }

    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      style="width: 20%"
      >
      <mat-label>Search</mat-label>
      <input matInput type="text" (keyup)="applyFilter($event)" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  @if (settingsFound) {
    <div class="break">
      <button
        mat-fab
        extended
        [color]="'buttonSuccess'"
        (click)="createSetting()"
        class="button"
        >
        <mat-icon>add</mat-icon>
        Create
      </button>
    </div>
  }

  @if (settingsFound) {
    <div class="content-container">
      <div class="content-list__list">
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)">
          <!-- setting Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let setting">{{ setting.name }}</td>
          </ng-container>
          <!-- setting asset type Column -->
          <ng-container matColumnDef="asset">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Asset Type</th>
            <td mat-cell *matCellDef="let setting">
              @if (setting.still != null && setting.video != null) {
                <div>
                  Combo
                </div>
              }
              @if (setting.still != null && setting.video == null) {
                <div>
                  Still
                </div>
              }
              @if (setting.still == null && setting.video != null) {
                <div>
                  Video
                </div>
              }
            </td>
          </ng-container>
          <!-- Setting type Column -->
          <ng-container matColumnDef="settingType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
            <td mat-cell *matCellDef="let setting">
              @if (setting.type == null) {
                <div>Stevie</div>
              } @else {
                {{ setting.type }}
              }
            </td>
          </ng-container>
          <!-- Product Count Column -->
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sort>
              Creation Date
            </th>
            <td mat-cell *matCellDef="let setting">
              <div
              matTooltip="{{
                setting.createdAt | dateAgo : currentConfigDate : true | async
              }}"
                matTooltipPosition="before"
                >
                {{ setting.createdAt | dateAgo : currentConfigDate | async }}
              </div>
            </td>
          </ng-container>
          <!-- Actions Column -->
          <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let setting" style="text-align: right">
              <button
                mat-icon-button
                matTooltip="Info"
                color="info"
                class="mat-elevation-z0"
                (click)="updateSetting(setting)"
                >
                <mat-icon>info</mat-icon>
              </button>
              <button
                [matMenuTriggerFor]="actionsMenu"
                mat-icon-button
                matTooltip="More"
                color="primary"
                class="mat-elevation-z0"
                >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #actionsMenu="matMenu">
                @if (authService.hasPermission(Permission.SettingsFull)) {
                  <button
                    mat-menu-item
                    (click)="deleteSetting(setting)"
                    >
                    <mat-icon matTooltip="Delete" color="error">delete</mat-icon>
                    <span>Delete</span>
                  </button>
                }
                <button mat-menu-item (click)="copySetting(setting)">
                  <mat-icon matTooltip="Copy" color="primary"
                    >content_copy</mat-icon
                    >
                    <span>Copy</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="copySettingAcrossOrganization(setting)"
                    >
                    <mat-icon matTooltip="Copy" color="primary">copy_all</mat-icon>
                    <span>Copy to Organization</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        <mat-paginator
          class="mat-paginator-sticky"
          [pageSizeOptions]="[10, 20, 50, 100]"
          showFirstLastButtons
          [pageSize]="currentConfigDate.pageSize"
          (page)="setPageSizePreference($event)"
          >
        </mat-paginator>
      </div>
    }
  </div>
